import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';

let StyledMenuItem = styled(MenuItem)({
    fontSize: '16px'
});

type BaseMenuProps = {
    onClick: any;
    route: string;
    label: string;
};

const BaseMenuItem = (props: BaseMenuProps) => {
    let { onClick, route, label } = props;

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        let ctrlKey: boolean = event.ctrlKey;

        return ctrlKey && route != null ? window.open(route, '_blank') : onClick(event);
    };
    return (
        <StyledMenuItem onClick={handleClick} route={route}>
            {label}
        </StyledMenuItem>
    );
};

export default BaseMenuItem;
